import AddSynonym, { AddIcon, LoaderIcon } from './AddSynonym'

export default AddSynonym
export { AddIcon, LoaderIcon }
